import { createUseStyles } from "react-jss";
import { inputMaxWidth, inputMinWidth } from "../../theme/Mixins";

export default createUseStyles({
    guidedMessage:{
        fontSize: '14px',
        color: '#667085',
        marginTop: '5px',
        lineHeight: '1.2',
        maxWidth:({theme, size }) => inputMaxWidth(theme, size),
        minWidth: ({theme, size }) => inputMinWidth(theme, size),
    }
})